import { useEffect } from 'react';

const SEOMetadata = ({
  title,
  description,
  canonicalUrl,
  ogImage,
  ogType = 'website',
  schemaData
}) => {
  useEffect(() => {
    // 1. Update Title
    if (title) {
      document.title = title;
    }

    // Helper to update or create meta tags
    const updateMetaTag = (attr, attrValue, contentValue) => {
      if (!contentValue) return;
      let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute('content', contentValue);
    };

    // Helper to update or create link tags
    const updateLinkTag = (rel, hrefValue) => {
      if (!hrefValue) return;
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
      }
      el.setAttribute('href', hrefValue);
    };

    // 2. Meta description
    updateMetaTag('name', 'description', description);

    // 3. Canonical Link
    const finalCanonical = canonicalUrl || window.location.origin + window.location.pathname;
    updateLinkTag('canonical', finalCanonical);

    // 4. OpenGraph
    updateMetaTag('property', 'og:title', title);
    updateMetaTag('property', 'og:description', description);
    updateMetaTag('property', 'og:type', ogType);
    updateMetaTag('property', 'og:url', finalCanonical);
    updateMetaTag('property', 'og:image', ogImage || 'https://testingvala.com/testingvala-logo.png');

    // 5. Twitter Card
    updateMetaTag('name', 'twitter:card', 'summary_large_image');
    updateMetaTag('name', 'twitter:title', title);
    updateMetaTag('name', 'twitter:description', description);
    updateMetaTag('name', 'twitter:image', ogImage || 'https://testingvala.com/testingvala-logo.png');

    // 6. JSON-LD Schema
    let schemaScript = document.getElementById('seo-json-ld');
    if (schemaData) {
      if (!schemaScript) {
        schemaScript = document.createElement('script');
        schemaScript.id = 'seo-json-ld';
        schemaScript.type = 'application/ld+json';
        document.head.appendChild(schemaScript);
      }
      schemaScript.textContent = JSON.stringify(schemaData);
    } else {
      if (schemaScript) {
        schemaScript.remove();
      }
    }
  }, [title, description, canonicalUrl, ogImage, ogType, schemaData]);

  return null;
};

export default SEOMetadata;
